module.exports = __webpack_public_path__ + "static/media/plus_green.929a9ff7.svg";